import * as types from '@/store/mutation-types';

const mutations = {
  [types.UPDATE_GENERAL_TEXT](state, p) {
    const drp = p.drp;
    drp.text = p.text;
  },
};

const actions = {
  async updateGeneralText({ dispatch, commit }, payload) {
    await commit(types.UPDATE_GENERAL_TEXT, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-general/vuex.js